module.exports = __webpack_public_path__ + "static/media/online_payment_.47602a0c.svg";